module.exports = __webpack_public_path__ + "static/media/deadfuck-logo-black.3c2a1453.png";